<template>
  <v-card max-width="100%" outlined class="mr-0">
    <v-app-bar dark dense color="red lighten-1" elevation="0">
      <v-col cols="10" class="d-flex justify-start">
        <v-toolbar-title>Lista de Items Tombados</v-toolbar-title>
      </v-col>
      <v-col class="d-flex justify-end" v-if="selected_item.amount > registered_item_number">
        <FormCreateAsset :itemId="itemId" />
      </v-col>
    </v-app-bar>
    <v-data-table
      :headers="headers"
      :items="selected_item_assets"
      :items-per-page="6"
      :search="search"
      :custom-filter="filterItems"
      class="elevation-1"
    >
      <template v-slot:top>
        <v-text-field v-model="search" label="Pesquisar" class="mx-4"></v-text-field>
      </template>

      <!-- <template v-slot:[`item.actions`]="{ item }">
        <v-row>
          <v-col class="d-flex justify-end">
            <InvoiceDetailing :externalAccess="false" :invoiceId="item.id" />
          </v-col>
          <v-col class="d-flex justify-end">
            <v-btn text medium icon @click="modalDeleteItem(item.id)">
              <v-icon medium color="red lighten-1"> mdi-close-box-outline </v-icon>
            </v-btn>
          </v-col>
        </v-row>
      </template> -->
    </v-data-table>
  </v-card>
</template>

<script>
import { mapState } from 'vuex'
import FormCreateAsset from '@/views/home/components/FormCreateAsset'

export default {
  name: 'RegisteredInvoiceItems',
  components: { FormCreateAsset },
  props: { itemId: Number },
  data() {
    return {
      search: '',
      registered_item_number: '',
      selected_item_assets: [],
      selected_item: {},
      headers: [
        {
          text: 'Nº Tombo',
          align: 'start',
          value: 'asset_number',
        },
        { text: 'Filial', value: 'target_workstation' },
        { text: 'Departamento', value: 'target_department' },
        { text: 'Data do Tombo', value: 'record_date' },
        { text: '', value: 'actions', sortable: false },
      ],
    }
  },
  created() {
    this.selected_item = this.invoice_items.find((item) => {
      return item.id === this.itemId
    })

    this.selected_item_assets = this.assets.filter((item) => {
      return item.invoice_item_id === this.itemId
    })

    this.registered_item_number = this.selected_item_assets.length
  },
  computed: {
    ...mapState('assets', ['assets']),
    ...mapState('acquisitions', ['invoice_items']),
  },
  watch: {
    invoice_items: function () {
      this.selected_item = this.invoice_items.find((item) => {
        return item.id === this.itemId
      })
    },
    assets: function () {
      this.selected_item_assets = this.assets.filter((item) => {
        return item.invoice_item_id === this.itemId
      })
      this.registered_item_number = this.selected_item_assets.length
    },
  },
  methods: {
    filterItems(value, search, item) {
      search = search.toUpperCase()

      return (
        value != null &&
        search != null &&
        typeof value === 'string' &&
        value.toString().toLocaleUpperCase().indexOf(search) !== -1
      )
    },
  },
}
</script>